import { render, staticRenderFns } from "./DossierListe.vue?vue&type=template&id=50b84ccc&scoped=true&"
import script from "./DossierListe.js?vue&type=script&lang=js&"
export * from "./DossierListe.js?vue&type=script&lang=js&"
import style0 from "./DossierListe.vue?vue&type=style&index=0&id=50b84ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b84ccc",
  null
  
)

export default component.exports